import React, { useState } from "react";
import { LoadingSVG } from "../icons/SVGIcon";
import { useDispatch } from "react-redux";
import { setGlobalLoading, setGlobalToastr } from "src/store/actions";
import { Icon, Tooltip } from "antd";
import { send_multiple_apt_schedules } from "src/services/api.services";

export default function ButtonCheckTwo({ onClick = () => {}, title = "", alternateTitle = "", styleProps, patientId }) {
  const [active, setActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleClick = async () => {
    dispatch(setGlobalLoading(true));
    setLoading(true);
    const sendAPT = await send_multiple_apt_schedules({
      patient_id: patientId,
    });
    if (sendAPT) {
      dispatch(setGlobalLoading(false));
      setLoading(false);
      setActive(false);
      dispatch(
        setGlobalToastr({
          header: "Send Appointment Schedule!",
          message: "Send Appointment Schedule Successfully!",
          type: "success",
        })
      );
    } else {
      dispatch(setGlobalLoading(false));
      setLoading(false);
      setActive(false);
      dispatch(
        setGlobalToastr({
          header: "Send Appointment Schedule!",
          message: "Send Appointment Schedule failed!",
          type: "failed",
        })
      );
    }
  };

  return (
    <div
      style={{ height: 50, width: "100%", display: "flex", flexDirection: "column", justifyItems: "center", alignItems: "flex-end", ...styleProps }}
    >
      <div className="detailContent">
        <button
          style={{ width: "auto !important", minWidth: 236 }}
          className={"common-btn blue-btn"}
          onClick={(e) => {
            e.preventDefault();
            if (!active) {
              setActive(true);
            } else {
              handleClick();
            }
          }}
        >
          {loading ? (
            <div className="loading-icon loading-vital-ros">
              <div style={{ width: 40, height: 40 }}>
                <LoadingSVG color={"#fff"} />
              </div>
            </div>
          ) : (
            <div style={{ width: "100%", flexDirection: "row", display: "flex" }}>
              <div style={{ width: "calc(100% - 30px)" }}>
                <span>{active ? alternateTitle : title}</span>
              </div>
            </div>
          )}
        </button>
      </div>
    </div>
  );
}
